import React from "react";
import { fireEvent, render, screen, waitFor } from "@testing-library/react";
import "@testing-library/jest-dom";
import ElementGrantsEditor from "./ElementGrantsEditor";

const mockAuthFetch = jest.fn();
jest.mock("../../../../utils/useAuthFetch", () => ({
  useAuthFetch: () => mockAuthFetch,
}));
jest.mock("../../hooks/useGroups", () => ({
  useGroups: () => ({
    groups: [{ id: "group-1", display_name: "Reviewers" }],
    loading: false,
    error: null,
  }),
}));

describe("ElementGrantsEditor", () => {
  beforeEach(() => {
    mockAuthFetch.mockReset().mockImplementation(async (_url, tag, options) => {
      if (tag === "load element grants")
        return [{ group_id: "group-1", level: "read" }];
      if (tag === "update element grant") {
        const grant = JSON.parse(options.body);
        return grant.level === "inherit" ? null : grant;
      }
      throw new Error(`Unexpected request: ${tag}`);
    });
  });

  it("persists an explicit deny and removes only an inherited override", async () => {
    render(
      <ElementGrantsEditor
        workspaceId="workspace-1"
        canvasId="canvas-1"
        elementId="element-1"
      />,
    );
    const access = await screen.findByRole("combobox", { name: "Reviewers" });
    await waitFor(() => expect(access).toHaveTextContent("Read"));

    fireEvent.click(access);
    fireEvent.click(screen.getByRole("option", { name: "Read and write" }));
    await waitFor(() =>
      expect(mockAuthFetch).toHaveBeenCalledWith(
        "/api/workspace/myvault/canvases/canvas-1/elements/element-1/grants",
        "update element grant",
        expect.objectContaining({
          method: "PUT",
          body: JSON.stringify({ group_id: "group-1", level: "read-write" }),
        }),
      ),
    );
    await waitFor(() => expect(access).toHaveTextContent("Read and write"));

    fireEvent.click(access);
    fireEvent.click(screen.getByRole("option", { name: "None" }));
    await waitFor(() => expect(access).toHaveTextContent("None"));
    expect(mockAuthFetch).toHaveBeenCalledWith(
      "/api/workspace/myvault/canvases/canvas-1/elements/element-1/grants",
      "update element grant",
      expect.objectContaining({
        body: JSON.stringify({ group_id: "group-1", level: "none" }),
      }),
    );

    fireEvent.click(access);
    fireEvent.click(screen.getByRole("option", { name: "Inherit" }));
    await waitFor(() => expect(access).toHaveTextContent("Inherit"));
    expect(mockAuthFetch).toHaveBeenCalledWith(
      "/api/workspace/myvault/canvases/canvas-1/elements/element-1/grants",
      "update element grant",
      expect.objectContaining({
        body: JSON.stringify({ group_id: "group-1", level: "inherit" }),
      }),
    );
  });
});
